export default "__VITE_ASSET__sEnq$dat__"